import { render, staticRenderFns } from "./FullNameInput.vue?vue&type=template&id=6042cad0&scoped=true&"
import script from "./FullNameInput.vue?vue&type=script&lang=js&"
export * from "./FullNameInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6042cad0",
  null
  
)

export default component.exports